import React from "react";
import { makeStyles } from "tss-react/mui";
import "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import "@mui/material";
import "../alerts/Message.style.js";
import { MessageWithIcon } from "../alerts/MessageWithIcon.js";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import "./Form.js";
import { FormLabel } from "./FormLabel.js";
import "./ToggleSwitch.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  formControlGroup: {
    backgroundColor: "transparent",
    color: theme.custom.palette.content.bodyText,
    width: "100%"
  },
  formControlGroupWithLeftLabel: {
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    alignItems: "start",
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(1)
  },
  formControlGroupInputs: {
    width: "100%"
  },
  formControlGroupHint: {
    color: theme.palette.secondary.main,
    gridColumn: 2
  }
}));
function FormControlGroup({
  children,
  label,
  labelVariant = "caption",
  labelPlacement = "top",
  hint
}) {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(
        {
          [classes.formControlGroupWithLeftLabel]: label && labelPlacement === "left"
        },
        classes.formControlGroup
      )
    },
    label ? /* @__PURE__ */ React.createElement(FormLabel, { label, labelVariant }) : null,
    /* @__PURE__ */ React.createElement("div", { className: classes.formControlGroupInputs }, children),
    hint ? /* @__PURE__ */ React.createElement(MessageWithIcon, { className: classes.formControlGroupHint, icon: CustomIcon.WarningOutline, label: hint }) : null
  );
}
export {
  FormControlGroup
};
//# sourceMappingURL=FormControlGroup.js.map
